import ExtendableError from '../lib/ExtendableError';

export class IBlocksCompleteJourneyError extends ExtendableError { name = 'IBlocksCompleteJourneyError'; }

export class IBlocksApiError extends ExtendableError { name = 'IBlocksApiError'; }
